export const NON_REGISTRABLE_STATUS = ['fully-booked', 'planned', 'on-demand'];
